import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import * as campaignActions from "../../../redux/actions/CampaignsActions";
import { getCampaignListDetails } from '../../../redux/actions/CampaignListsActions';
import CampaignListInfo from './CampaignListInfo';
import CampaignListApplicationsTable from './CampaignListApplicationsTable';
import { toastr } from 'react-redux-toastr';
import { formatNumber, formatDate, formatCurrency, locationIsIsraeli } from '../../../lib/utils';
import { ApplicationStatuses, PermissionTypes } from '../../../lib/systemVariables';

class CampaignListApplicationsPage extends NavigationComponent {
    constructor(props) {
        super(props);
    
        this.state = {
          campaignListId: this.props.match.params.listId,
          campaignId: this.props.match.params.campaignId
        }
    }

    componentWillMount() {
      if (this.state.campaignId && this.state.campaignListId) {
        this.getDetails();
      }
    }

    componentWillUnmount() {
      this.props.actions.clearCampaignListApplications();
    }

    async getDetails() {
      await this.props.actions.getCampaignDetails(this.state.campaignId);
      if (!this.props.campaignDetails.details.success) {
        toastr.error('Something went wrong', `We were unable to retrieve campaign details.  Please try again.`);
      }

      await this.props.actions.getCampaignListDetails(this.state.campaignListId);
      if (!this.props.details.success) {
        toastr.error("Something went wrong!", `We were unable to retrieve campaign list details.  Please try again.`);
      }
    }

    updateStatus(status) {
      if (status !== this.props.campaignListApplications.applicationStatus) {
        const sort = this.props.clApplicationsTable.sort;
        const resultsView = this.props.clApplicationsTable.resultsView;

        this.props.actions.updateCampaignListApplicationsStatus(status);
        this.props.actions.getCampaignListApplications(this.state.campaignId, this.state.campaignListId, 1, resultsView, sort);
      }
    }
    
    render() {
      const campaignList = this.props.details.data;
      const campaign = this.props.campaignDetails.details.data;
      campaign.isIsraeli = locationIsIsraeli(this.props.locationGroups, campaign.locationId);
      
      const {totalCreated, totalPaid } = this.props.clApplicationsTable.data;
      const applicationStatus = this.props.campaignListApplications.applicationStatus;
      const maxAmount = campaign.isIsraeli ? campaign.maxAmountShekel : campaign.maxAmountDollar;
      const table = this.props.clApplicationsTable;

      return (
        <div className="page campaign-list">
          <div className="subheader campaign-header">
            <div className="container flex-justify">
              <div className="full-width">
                {this.props.campaignDetails.details.loading ? <LoadingSpinner height="20" />
                  : (campaign.campaignId &&
                     <div className="flex-center campaign-list-details-header">
                      <h1> {campaign.name} </h1>
                      <div className="flex-center">
                        <p className="small-text"><i className="icon-calendar icon-left accent-text2"></i>{formatDate(campaign.dateCreated)} - {formatDate(campaign.endDate)}</p>
                        <p className="small-text">
                          {campaign.isIsraeli ? <i className="material-icons shekel-icon icon icon-left accent-text2">₪</i> : <i className="icon ion-social-usd icon-left accent-text2"></i>}
                          {formatCurrency(maxAmount, campaign.isIsraeli)} limit
                        </p>
                      </div>
                    </div>)}
                {this.props.details.loading ? <LoadingSpinner height="20" />
                  : (campaignList.campaignListId && <div>
                    <CampaignListInfo
                      campaignList= {campaignList}/>
                  </div>)}
              </div>
              <div className="back-link">
                <i className="icon ion-android-arrow-back middle medium-text"></i>
                <span className="link-text small-text" onClick={this.props.history.goBack}>
                  Back to Campaigns
                </span>
              </div>
            </div>
          </div>
          
          <div className="campaign-applications">
            <div className="container flex-center flex-justify">
              <div className="info-row">
                <div className="container">
                      <div className="application-options">
                          <p className={`application-option status-option-all ${!applicationStatus ? "active" : ""}`}
                              onClick={this.updateStatus.bind(this, null)}>
                              All Statuses
                          </p>
                          {Object.keys(ApplicationStatuses).map(statusKey => {
                              const status = ApplicationStatuses[statusKey];
                              const count = formatNumber(this.props.clApplicationsTable.data[statusKey.charAt(0).toLowerCase() + statusKey.slice(1)]);
                              return (
                                  <p key={statusKey}
                                      className={`application-option status-option-${statusKey.toLowerCase()} ${applicationStatus === statusKey ? "active" : ""}`}
                                      onClick={this.updateStatus.bind(this, statusKey)}>
                                      {status} <span className="status-option-count">{count}</span>
                                  </p>
                              );
                          })}
                      </div>
                  </div> 
                  <p className="medium-text">Total Created <span className="total-tag">{totalCreated}</span></p>
                  <p className="medium-text">Total Paid <span className="total-tag">{totalPaid}</span></p>
              </div>
            </div>
          </div>

          <CampaignListApplicationsTable
            {...this.props.clApplicationsTable}
            applicationStatus={applicationStatus}
            maxAmount={maxAmount}
            userPermissions={this.props.userPermissions}
            userId={this.props.userId}
            admin={this.props.admin}
            campaignId={campaign.campaignId}
            campaignListId={campaignList.campaignListId}
            campaignListName={campaignList.name}
            updateTable={this.props.actions.updateCampaignListApplicationsTable}
            updateApplication={async (app, update) => {
              await this.props.actions.updateCampaignListApplication(app, update);
              if (table.success) {
                this.props.actions.getCampaignListApplications(this.state.campaignId, this.state.campaignListId,
                  table.page, table.resultsView, { by: table.sort.by, direction: table.sort.direction });
              } 
            }}
            updateApplicationStatus={async (action, app) => {
              await this.props.actions.updateApplicationStatus(action, app);
              if (table.success) {
                this.props.actions.getCampaignListApplications(this.state.campaignId, this.state.campaignListId,
                  table.page, table.resultsView, { by: table.sort.by, direction: table.sort.direction });
              } 
            }}
            getCampaignListApplications={(...tableProps) => 
              this.props.actions.getCampaignListApplications(this.state.campaignId, this.state.campaignListId, ...tableProps || {})}/>
        </div>
      );
    }
}

function mapStateToProps(state, ownProps) {
    return {
      ...state.campaignListDetails, 
      campaignListApplications: state.campaignListApplications,
      campaignDetails: state.campaignDetails,
      locationGroups: state.settings.systemSettings.data.campaignSettings.locationGroups.filter(lg =>
        state.userProfile.profile.data.departments.indexOf(lg.department) >= 0),
      clApplicationsTable: state.campaignListApplicationsTable,
      userPermissions: {
        manage: state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsManage) >= 0,
        approveFull: state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsApproveFull) >= 0,
        approveLimited: state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsApproveLimited) >= 0
      },
      userId: state.userProfile.profile.data.userId,
      admin: state.userProfile.profile.data.roleId === 1
    }
  }

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...campaignActions, getCampaignListDetails },  dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignListApplicationsPage);



// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignListDetails/CampaignListApplicationsPage.jsx